export enum SystemPreferenceCode {
  metricSystemCode = 1,
  imperialSystemCode = 2,
}
